<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page :title="title">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-card 
           title-class="blue-gradient--bg white" 
           style="font-size: 14px;" 
           :title="'MAKLUMAT TERNAKAN'"
         >
         

       <!-- <template v-if="data.art && data.art.lkp_tujuan_id == 10"> -->
         <div class="gallery-grid">
              <div class="gallery-item" v-for="(image, index) in data.atthectment_image" :key="index">
                <div class="image-wrapper">
                  <img 
                    :src="image.url" 
                    :alt="image.name" 
                    @click="openZoomModal(image.url)"
                    class="gallery-image"
                  >
                </div>
                <div class="image-actions">
                  <a :href="image.url" target="_blank" class="mr2">
                    <w-icon xs>fal fa-search-plus</w-icon>
                  </a>
                  <!-- <w-button 
                    bg-color="error-dark1" 
                    @click="deletelAttahecmentImg(image.id)"
                  >
                    <w-icon xs>fal fa-trash</w-icon>
                  </w-button> -->
                </div>
              </div>
            </div>
        <!-- </template> -->


              
           <w-modal v-if="zoomModalVisible" @close="zoomModalVisible = false">
             <div class="zoom-modal-content">
               <img :src="zoomedImageUrl" class="full-zoom-image">
               <w-button 
                 class="close-zoom-btn" 
                 @click="zoomModalVisible = false"
                 bg-color="error"
               >
                 <w-icon>fal fa-times</w-icon>
               </w-button>
             </div>
           </w-modal>
           


           
           <div class="w-card__content content-hardcode">
             <div class="genital-exam-container">
               <div class="exam-grid">
                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                       <w-icon class="fal fa-circle exam-icon"></w-icon> No Pendaftaran :
                     </h3>
                     <span class="score-value">
                       {{ (data && data.ternakan && data.ternakan.kode) }}
                     </span>
                   </div>
                 </div>

                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                       <w-icon class="fal fa-circle exam-icon"></w-icon> ID / Nama Ternakan :
                     </h3>
                     <span class="score-value">
                       {{ (data && data.ternakan && data.ternakan.id_ternakan) }} / 
                       {{ (data && data.ternakan && data.ternakan.nama) }}
                     </span>
                   </div>
                 </div>

                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                       <w-icon class="fal fa-circle exam-icon"></w-icon> Jenis Ternakan :
                     </h3>
                     <span class="score-value">
                       {{ (data && data.ternakan && data.ternakan.lkp_ternakan.nama) }}
                     </span>
                   </div>
                 </div>

                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                       <w-icon class="fal fa-circle exam-icon"></w-icon> Baka :
                     </h3>
                     <span class="score-value">
                       {{ (data && data.ternakan && data.ternakan.lkp_baka.nama) }}
                     </span>
                   </div>
                 </div>

                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                       <w-icon class="fal fa-circle exam-icon"></w-icon> Jantina :
                     </h3>
                     <span class="score-value">
                       {{
                         data && data.ternakan && data.ternakan.jantina == 1
                           ? 'Jantan'
                           : data && data.ternakan && data.ternakan.jantina == 2
                           ? 'Betina'
                           : '-'
                       }}
                     </span>
                   </div>
                 </div>

                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                       <w-icon class="fal fa-circle exam-icon"></w-icon> Tarikh Lahir :
                     </h3>
                     <span class="score-value">
                       {{ (data && data.ternakan && data.ternakan.tarikh_lahir) }}
                     </span>
                   </div>
                 </div>


                  <div class="exam-item">
                    <div class="exam-header">
                      <h3 class="exam-title">
                        <w-icon class="fal fa-circle exam-icon"></w-icon> Warna :
                      </h3>
                      <span class="score-value">
                        {{ (data && data.lkp_warna) || (data && data.warna) || '-' }}
                      </span>
                    </div>
                  </div>

                  
                  <div class="exam-item">
                    <div class="exam-header">
                      <h3 class="exam-title">
                        <w-icon class="fal fa-circle exam-icon"></w-icon> Negara Asal :
                      </h3>
                      <span class="score-value">
                        {{ (data && data.negara_asal) || '-' }}
                      </span>
                    </div>
                  </div>
               </div>
             </div>
           </div>

           
         </w-card>
          <!-- <template v-if="data.art && data.art.lkp_tujuan_id == 10"> -->
            <w-card 
  title-class="blue-gradient--bg white" 
  style="font-size: 14px;" 
  :title="'CIRI - CIRI BAKA'"
>
  <div class="w-card__content content-hardcode">
    <div class="genital-exam-container">
      <span class="input-hint">**Adakah ciri-ciri baka berkaitan dengan ternakan ini?</span>
      &nbsp;
      <div class="exam-grid">
         <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Warna Bulu :
                  </h3>
                <span class="score-value">{{ data.warna_bulu == 1 ? 'Ya' : (data.warna_bulu == 2 ? 'Tidak' : 'Tidak Berkenaan') }}</span>
                    </div>
                    <div v-if="data.warna_bulu == 1" class="details">
                      {{ data.warna_bulu_nyatakan }}
                    </div>
               </div>


        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Saiz Kepala :
                  </h3>
                  <span class="score-value">{{ data.saiz_kepala == 1 ? 'Ya' : (data.saiz_kepala == 2 ? 'Tidak' : 'Tidak Berkenaan') }}</span>
                    </div>
                    <div v-if="data.saiz_kepala == 1" class="details">
                      {{ data.saiz_kepala_nyatakan }}
                    </div>
               </div>
        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Dahi :
                  </h3>
                  <span class="score-value">{{ data.dahi == 1 ? 'Ya' : (data.dahi == 2 ? 'Tidak' : 'Tidak Berkenaan') }}</span>
                    </div>
                    <div v-if="data.dahi == 1" class="details">
                      {{ data.dahi_nyatakan }}
                    </div>
               </div>

        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Tanduk :
                  </h3>
                  <span class="score-value">{{ data.tanduk == 1 ? 'Ya' : (data.tanduk == 2 ? 'Tidak' : 'Tidak Berkenaan') }}</span>
                    </div>
                    <div v-if="data.tanduk == 1" class="details">
                      {{ data.tanduk_nyatakan }}
                    </div>
               </div>

        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Telinga :
                  </h3>
                  <span class="score-value">{{ data.telinga == 1 ? 'Ya' : (data.telinga == 2 ? 'Tidak' : 'Tidak Berkenaan') }}</span>
                    </div>
                    <div v-if="data.telinga == 1" class="details">
                      {{ data.telinga_nyatakan }}
                    </div>
               </div>

        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Bonggol :
                  </h3>
                  <span class="score-value">{{ data.bonggol == 1 ? 'Ya' : (data.bonggol == 2 ? 'Tidak' : 'Tidak Berkenaan') }}</span>
                    </div>
                    <div v-if="data.bonggol == 1" class="details">
                      {{ data.bonggol_nyatakan }}
                    </div>
               </div>
        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Ciri - Ciri Unik
                    <w-tooltip position="right">
                      <template #activator="{ on }">
                        <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                      </template>
                      Ciri - Ciri Unik
                    </w-tooltip>
                  </h3>
                <span class="score-value">{{ data.ciri == 1 ? 'Ya' : (data.ciri == 2 ? 'Tidak' : 'Tidak Berkenaan') }}</span>
                    </div>
                    <div v-if="data.ciri == 1" class="details">
                      {{ data.ciri_nyatakan }}
                    </div>
               </div>
              </div>
            </div>
          </div>
        </w-card>
          <!-- </template> -->
             
<!-- </template> -->

             <w-card 
           title-class="blue-gradient--bg white" 
           style="font-size: 14px;" 
           :title="'PEMERIKSAAN FIZIKAL'"
         >
           <div class="w-card__content content-hardcode">
             <div class="genital-exam-container">
               <div class="exam-grid">


                  <div class="exam-item">
                       <div class="exam-header">
                         <h3 class="exam-title">
                           <w-icon class="fal fa-circle exam-icon"></w-icon> Skor Kondisi Badan (BCS) :
                           <span class="score-value">{{data.skor}}</span>
                         </h3>
                       </div>
                     </div>



                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                        <w-icon class="fal fa-circle exam-icon"></w-icon> Berat :
                             <span class="score-value">{{data.berat}} KG</span>
                           </h3>
                        </div>
                 </div>

                 
                 <div class="exam-item">
                    <div class="exam-header">
                      <h3 class="exam-title">
                        <w-icon class="fal fa-circle exam-icon"></w-icon> Tanda Klinikal Penyakit :
                        <span class="score-value">{{ data.tanda_klinikan == 1 ? 'YA' : 'TIDAK' }}</span>
                      </h3>
                    </div>
                    <div v-if="data.tanda_klinikan == 1" class="details">
                      {{ data.tanda_klinikan_nyatakan }}
                    </div>
                  </div>

                  <div class="section-header full-width">
                 <h3 class="section-title"><i class="fal fa-bone"></i> Pemeriksaan Locomotor</h3>
               </div>

                  <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                        <w-icon class="fal fa-circle exam-icon"></w-icon> <i>Locomotor</i> :
                             <span class="score-value">{{ data.otot == 1 ? 'Normal' : 'Abnormal' }}</span>
                           </h3>
                   </div>
                   <div v-if="data.otot == 2" class="details">
                      {{ data.otot_nyatakan }}
                    </div>
                 </div>

                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                        <w-icon class="fal fa-circle exam-icon"></w-icon> Postur Kaki :
                           </h3>
                           <span class="score-value">{{ data.sendi == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                  <div v-if="data.sendi == 2" class="details">
                      {{ data.sendi_nyatakan }}
                    </div>
                 </div>

                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                        <w-icon class="fal fa-circle exam-icon"></w-icon> Postur Badan :
                           </h3>
                           <span class="score-value">{{ data.postur == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                   <div v-if="data.postur == 2" class="details">
                      {{ data.postur_nyatakan }}
                    </div>
                 </div>

                 
                 
               </div>
             </div>
           </div>
         </w-card>

         <w-card 
           title-class="blue-gradient--bg white" 
           style="font-size: 14px;" 
           :title="'PEMERIKSAAN ORGAN GENITAL LUARAN'"
         >
           <div class="w-card__content content-hardcode">
             <div class="genital-exam-container">
               <div class="exam-grid">

                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                        <w-icon class="fal fa-circle exam-icon"></w-icon> <i>Vulva</i> :
                           </h3>
                        <span class="score-value">{{ data.vulva == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                   <div v-if="data.vulva == 2" class="details">
                      {{ data.vulva_nyatakan }}
                    </div>
                 </div>

                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                        <w-icon class="fal fa-circle exam-icon"></w-icon> <i>Ambing Susu</i> :
                           </h3>
                           <span class="score-value">{{ data.ambing == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                   <div v-if="data.ambing == 2" class="details">
                      {{ data.ambing_nyatakan }}
                    </div>
                 </div>


                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                        <w-icon class="fal fa-circle exam-icon"></w-icon> <i>Puting Susu</i> :
                           </h3>
                        <span class="score-value">{{ data.puting == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                   <div v-if="data.puting == 2" class="details">
                      {{ data.puting_nyatakan }}
                    </div>
                 </div>

               </div>
             </div>
           </div>
         </w-card>


      <w-card 
        title-class="blue-gradient--bg white" 
        style="font-size: 14px;" 
        :title="'PEMERIKSAAN ORGAN GENITAL DALAMAN'"
      >
        <div class="w-card__content content-hardcode">
          <div class="genital-exam-container">
        <h3 class="section-title"><i class="fal fa-bone"></i> Servik</h3>
      </div>

      <div class="exam-grid">
        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Saiz :
                  </h3>
                    <span class="score-value">{{ data.saiz == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                   <div v-if="data.saiz == 2" class="details">
                      {{ data.saiz_nyatakan }}
                    </div>
                 </div>

        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Bentuk :
                  </h3>
                  <span class="score-value">{{ data.bentuk == 1 ? 'Lurus' : 'Bengkok' }}</span>
                   </div>
                 </div>

        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Lokasi :
                  </h3>
                  <span class="score-value">{{ data.lokasi == 1 ? 'Pelvic' : 'Abdomen' }}</span>
                   </div>
                 </div>

        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Kekenyalan :
                  </h3>
                <span class="score-value">{{ data.kekenyalan == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                   <div v-if="data.kekenyalan == 2" class="details">
                      {{ data.kekenyalan_nyatakan }}
                    </div>
                 </div>
         
      </div>
      <div class="section-header full-width">
        <h3 class="section-title" style="margin-top: 15px;"><i class="fal fa-bone"></i> Uterus</h3>
      </div>
       <div class="exam-grid">
        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Simetri :
                  </h3>
                <span class="score-value">{{ data.simetri == 1 ? 'Ya' : 'Tidak' }}</span>
                   </div>
                   <div v-if="data.simetri == 1" class="details">
                      {{ data.simetri_nyatakan }}
                    </div>
                 </div>

        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Bunting :
                  </h3>
                <span class="score-value">{{ data.bunting == 1 ? 'Ya' : 'Tidak' }}</span>
                   </div>
                   <div v-if="data.bunting == 1" class="details">
                      {{ data.bunting_nyatakan }}
                    </div>
                 </div>

        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Kekenyalan
                    <w-tooltip position="right">
                      <template #activator="{ on }">
                        <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                      </template>
                      Pemeriksaan Kekenyalan Uterus
                    </w-tooltip>
                  </h3>
                <span class="score-value">{{ data.kekenyalan_uterus == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                   <div v-if="data.kekenyalan_uterus == 2" class="details">
                      {{ data.kekenyalan_uterus_nyatakan }}
                    </div>
                 </div>

        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Saiz Uterus :
                  </h3>
                <span class="score-value">{{ data.saiz_uterus == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                   <div v-if="data.saiz_uterus == 2" class="details">
                      {{ data.saiz_uterus_nyatakan }}
                    </div>
                 </div>

      </div>
        <div class="section-header full-width">
        <h3 class="section-title" style="margin-top: 15px;"><i class="fal fa-bone"></i> Ovari</h3>
      </div>
       <div class="exam-grid">
        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Saiz Ovari :
                  </h3>
                <span class="score-value">{{ data.saiz_ovari == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                   <div v-if="data.saiz_ovari == 2" class="details">
                      {{ data.saiz_ovari_nyatakan }}
                    </div>
                 </div>

        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Bentuk :
                  </h3>
                <span class="score-value">{{ data.bentuk_ovari == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                   <div v-if="data.bentuk_ovari == 2" class="details">
                      {{ data.bentuk_ovari_nyatakan }}
                    </div>
                 </div>
          

        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Kekenyalan
                    <w-tooltip position="right">
                      <template #activator="{ on }">
                        <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                      </template>
                      Pemeriksaan Kekenyalan Ovari
                    </w-tooltip>
                  </h3>
                <span class="score-value">{{ data.kekenyalan_ovari == 1 ? 'Normal' : 'Abnormal' }}</span>
                   </div>
                   <div v-if="data.kekenyalan_ovari == 2" class="details">
                      {{ data.kekenyalan_ovari_nyatakan }}
                    </div>
                 </div>

      </div>
      <div class="section-header full-width">
        <h3 class="section-title" style="margin-top: 15px;"><i class="fal fa-bone"></i> Kehadiran Discaj</h3>
      </div>
       <div class="exam-grid">
        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Kehadiran
                    <w-tooltip position="right">
                      <template #activator="{ on }">
                        <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                      </template>
                      Kehadiran
                    </w-tooltip>
                  </h3>
                <span class="score-value">{{ data.kehadiran == 1 ? 'Ya' : 'Tidak' }}</span>
                   </div>
                   <div v-if="data.kehadiran == 2" class="details">
                      {{ data.kehadiran_nyatakan }}
                    </div>
                 </div>
                  </div>
                </div>
              </w-card>

         <w-card 
           title-class="blue-gradient--bg white" 
           style="font-size: 14px;" 
           :title="'STATUS PEMERIKSAAN PENYAKIT (DOKUMEN)'"
         >
           <div class="w-card__content content-hardcode">
             <div class="genital-exam-container">
               <div class="exam-grid">
                 <div class="exam-item mb4" v-for="(dt, ind) in data.lkp_penyakit_fe" :key="ind">
                   <div class="exam-header mb2">
                     <h3 class="exam-title">
                       <w-icon class="fal fa-circle exam-icon"></w-icon> {{ dt.label }} : <span class="score-value">{{ dt.status == 1 ? 'Positif' : (dt.status == 2 ? 'Negatif' : 'Belum Di Uji') }}</span>
                       
                     </h3>
                   </div>
                   
                 </div>
               </div>
             </div>
           </div>
         </w-card>

          <w-card 
           title-class="blue-gradient--bg white" 
           style="font-size: 14px;" 
           :title="'STATUS PEMERIKSAAN PENYAKIT (FIZIKAL)'"
         >
           <div class="w-card__content content-hardcode">
             <div class="genital-exam-container">
               <div class="exam-grid">
                 <div class="exam-item mb4" v-for="(dt, ind) in data.lkp_penyakit_fizikal_fe" :key="ind">
                   <div class="exam-header mb2">
                     <h3 class="exam-title">
                       <w-icon class="fal fa-circle exam-icon"></w-icon> {{ dt.label }} : <span class="score-value">{{ dt.status == 1 ? 'Ada' : (dt.status == 2 ? 'Tiada Tanda Klinikal' : 'Tiada Tanda Klinikal') }}</span>
                       
                     </h3>
                   </div>
                    <div v-if="dt.status == 1" class="details">
                      {{ dt.nyatakan }}
                    </div>
                   
                 </div>
               </div>
             </div>
           </div>
         </w-card>


         <w-card 
           title-class="blue-gradient--bg white" 
           style="font-size: 14px;" 
           :title="'SIFAT TERNAKAN'"
         >
           <div class="w-card__content content-hardcode">
             <div class="genital-exam-container">
               <div class="exam-grid">

                 <!-- Testis -->
                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                        <w-icon class="fal fa-circle exam-icon"></w-icon> Sifat Ternakan :
                           </h3>
                           <span class="score-value">{{ data.temprament == 1 ? 'Jinak' : 'Agresif' }}</span>
                   </div>
                   <div v-if="data.temprament == 2" class="details">
                      {{ data.temprament_nyatakan }}
                    </div>
                 </div>
               </div>
             </div>
           </div>
         </w-card>
         <w-card 
           title-class="blue-gradient--bg white" 
           style="font-size: 14px;" 
           :title="'STATUS PEMERIKSAAN'"
         >
           <div class="w-card__content content-hardcode">
             <div class="genital-exam-container">
               <div class="exam-grid">
                 <div class="exam-item">
                   <div class="exam-header">
                     <h3 class="exam-title">
                       <w-icon class="fal fa-circle exam-icon"></w-icon> Status Pemeriksaan :
                     </h3>
                     <span class="score-value">{{ data.lkp_status_id == 22 ? 'Lulus' : (data.lkp_status_id == 38 ? 'Lulus Bersyarat' : 'Gagal') }}</span>
                   </div>
                   <div v-if="data.lkp_status_id == 38" class="details">
                      {{ data.status_nyatakan }}
                    </div>
                 </div>
               </div>
             </div>
           </div>
         </w-card>
       <!-- <template v-if="$zutil.anyRole(['4','6']) && data.art && data.art.lkp_tujuan_id == 10"> -->
       <template v-if="$zutil.anyRole(['1','4','6'])">
         <w-card 
           title-class="blue-gradient--bg white" 
           style="font-size: 14px;" 
           :title="'SARANAN PENYEMAK'"
         >
           <div class="w-card__content content-hardcode">
             <div class="genital-exam-container">
               <div class="exam-grid">
                 <div class="exam-item">
                   <!-- <div class="exam-header"> -->
                     <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
                       <template #title>
                         SARANAN PENYEMAK
                       </template>
                       <div class="w-table-wrap" style="max-height: 700px;">
                         <div class="table-profil-scrol">
                    <template  v-if="data.baka_status == 34 && $zutil.anyRole(['4'])">
                           <table class="w-table" color="light">
                             <thead>
                               <tr>
                               <th class="w-table__header text-center" width="1%">BIL</th>
                               <th class="w-table__header text-center">KATEGORI</th>
                               <th class="w-table__header text-left">KETERANGAN</th>
                                   <th class="w-table__header text-center" >(PILIH SATU SAHAJA)</th>
                           </tr>
                           </thead>
                              <tbody >
                              <template v-for="(dt, ind) in data.baka_saranan_list" :key="dt.id">
                                  <tr class="w-table__row">
                                    <td class="w-table__cell text-center">{{ind+1}}</td>
                                    <td class="w-table__cell text-center">{{dt.nama}}</td>
                                    <td class="w-table__cell text-left" v-html="nl2br(dt.keterangan)"></td>
                                    <td class="w-table__cell text-center">
                                      <div class="title4 mb2"></div>
                                     <w-checkbox :model-value="form.lkp_baka_saranan_id === dt.id" 
                                 @update:model-value="val => klickPi(dt, val)"></w-checkbox>
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                           </table>
                     </template>


                    <template v-else-if="$zutil.anyRole(['1','4','6']) && (data.baka_status == 18 || data.baka_status == 21 || data.baka_status == 30)">

              <!-- pelulus -->
                           <table class="w-table" color="light">
                             <thead>
                               <tr>
                                 <th class="w-table__header text-center" width="1%">BIL</th>
                                 <th class="w-table__header text-center">KATEGORI</th>
                                 <th class="w-table__header text-left">KETERANGAN</th>
                               </tr>
                             </thead>
                             <tbody >

                                <template v-for="(dt, ind) in data.baka_saranan_list.filter(t => t.lkp_baka_saranan_id != null)" :key="dt.id" >
                                  <tr class="w-table__row">
                                    <td class="w-table__cell text-center">{{ind+1}}</td>
                                    <td class="w-table__cell text-center">{{dt.nama}}</td>
                                    <td class="w-table__cell text-left" v-html="nl2br(dt.keterangan)"></td>
                                  </tr>

                                </template>
                             </tbody>
                           </table>
                    </template>

                         </div>
                       </div>
                     </w-form>
                 </div>
               <!-- </div> -->
             </div>
           </div>
           </div>
         </w-card>
      
       <!-- <template v-if="$zutil.anyRole(['6']) && data.art && data.art.lkp_tujuan_id == 10"> -->
       <template v-if="$zutil.anyRole(['1','6'])&& (data.baka_status == 18 || data.baka_status == 21 || data.baka_status == 30) ">
         <w-card 
           title-class="blue-gradient--bg white" 
           style="font-size: 14px;" 
           :title="'KEPUTUSAN PELULUS'"
         >
           <div class="w-card__content content-hardcode">
             <div class="genital-exam-container">
               <div class="exam-grid">
                 <div class="exam-item">
                   <!-- <div class="exam-header"> -->
                     <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
                       <template #title>
                         KEPUTUSAN PELULUS
                       </template>
                       <div class="w-table-wrap" style="max-height: 700px;">
                         <div class="table-profil-scrol">

                    <template  v-if="data.baka_status == 30">
                           <table class="w-table" color="light">
                            <thead>
                                <tr>
                                  <th class="w-table__header text-center" width="1%">BIL</th>
                                  <th class="w-table__header text-center">KATEGORI</th>
                                  <th class="w-table__header text-left">KETERANGAN</th>
                                  <th class="w-table__header text-center" >(PILIH SATU SAHAJA)</th>
                                </tr>
                            </thead>
                            <tbody>
                              <template v-for="(dt, ind) in data.baka_saranan_pelulus_list" :key="dt.id">
                                  <tr class="w-table__row">
                                    <td class="w-table__cell text-center">{{ind+1}}</td>
                                    <td class="w-table__cell text-center">{{dt.nama}}</td>
                                    <td class="w-table__cell text-left" v-html="nl2br(dt.keterangan)"></td>
                                    <td class="w-table__cell text-center">
                                      <div class="title4 mb2"></div>
                                      <w-checkbox :model-value="form.lkp_baka_saranan_pelulus_id === dt.id" 
                                      @update:model-value="val => klickPiPelulus(dt, val)"></w-checkbox>
                                    </td>
                                  </tr>
                                </template>
                            </tbody>
                          </table>
                      </template>
                       <template v-else-if="$zutil.anyRole(['1','4','6']) && (data.baka_status == 18 || data.baka_status == 21)">
                        <table class="w-table" color="light">
                            <thead>
                                <tr>
                                  <th class="w-table__header text-center" width="1%">BIL</th>
                                  <th class="w-table__header text-center">KATEGORI</th>
                                  <th class="w-table__header text-left">KETERANGAN</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(dt, ind) in data.baka_saranan_pelulus_list.filter(t => t.lkp_baka_saranan_pelulus_id != null)" :key="dt.id" >
                                  <tr class="w-table__row">
                                    <td class="w-table__cell text-center">{{ind+1}}</td>
                                    <td class="w-table__cell text-center">{{dt.nama}}</td>
                                    <td class="w-table__cell text-left" v-html="nl2br(dt.keterangan)"></td>
                                  </tr>
                                </template>
                            </tbody>
                          </table>

                       </template>
                         </div>
                       </div>
                     </w-form>
                 </div>
               <!-- </div> -->
             </div>
           </div>
           </div>
         </w-card>
       </template>



         <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1','4','6']) ">
          <template v-if="data.baka_status == 18 || data.baka_status == 21">
                
            </template>
            <template v-else>
              <w-button class="my1" bg-color="success" type="submit" :loading="form.submitted && !form.sent"  @click="send(form.lkp_baka_saranan_id, form.lkp_baka_saranan_pelulus_id)"> 
                <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
              </w-button>
            </template>
      </w-flex>
   </template>


<!-- 
         <template v-if="$zutil.anyRole(['1','6']) ">
        <div class="mt2 text-left">
          <w-button bg-color="grey-light5--bg" @click="tutup1">TUTUP</w-button>&nbsp;
        </div>
      </template> -->

      <!-- <template v-else> -->
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      <!-- </template> -->
     </div>
  </div>
      </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id : [Object],
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan.penilaian.fe_show',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Perkhidmatan Daya Biak', route: '/pdbf' },
        { label: 'Papar', route: '/pdbf/penilaian' },
      ],
      title : 'Pdbf Penilaian',
      img: null,
      zoomModalVisible: false,
      zoomedImageUrl: '',
      form : this.d_form,
      form: {
      lkp_baka_saranan_id: ''
    },
      
      
      pencarian: {
         no_kes_id: '',
         ternakan_id: '',
      },
      no_kes_id: [],
      ternakan_id:[],
      sejarah: [],
      baka_saranan_list:[],
      lkp_baka_saranan:[],
      lkp_penyakit_fe:[],
      
      
    }
  },
  methods: {

   send(hantar){
           this.form.hantar = hantar;
           // this.form.submitted = true;
           this.form.lkp_baka_saranan = this.baka_saranan_list
           this.form.lkp_baka_saranan_pelulus = this.baka_saranan_pelulus_list
           this.onSuccess(); 
         },

   onSuccess(){
      // alert(this.data.id);

      // this.form.ternakan_list = this.ternakan_list;
      this.form.id = this.data.id;
      this.form.lkp_baka_saranan = this.data.lkp_baka_saranan;
      this.form.lkp_baka_saranan_pelulus = this.data.lkp_baka_saranan_pelulus;
           // this.$zcomm.post(this.resourceurl + '/simpan_baka', this.form)
           this.$zcomm.update('baka.update.baka_butiran', this.form.id, this.form)
                  .then(res => {
                     if(this.form.hantar == 1 || this.form.hantar == 3){
                        this.$zutil.notify("Saranan Penyemak dihantar", true);
                        // this.$inertia.visit(this.$route('baka.index', res.id));
                        this.$inertia.visit(window.route('baka.permohonan.baka_show', this.data.baka_id));
                     }else{
                        this.$zutil.notify("Baka berjaya Disimpan", true);
                        this.$inertia.visit(this.$page.url)
                     }
                  })
                  .catch(error => {
                     this.$zutil.notify("Ralat ketika menghantar Baka", false);
                     console.error(error);
                  })
                  .finally(() => {
                     this.loading = false;
                  });
      
    },
       

    getData() {
     if (this.id > 0) {
       this.$zcomm.get(this.api_service + 'art/show_nilai/' + this.id, {}).then(res => {
         this.data = res;
         this.load = this.load + 1;
         
         
         if (this.data.baka_saranan_list) { 
           this.data.baka_saranan_list.forEach(item => {
             if (item.lkp_baka_saranan_id == item.id) {  
               this.klickPi(item, item.lkp_baka_saranan_id);
             }
           });
         }
         if (this.data.baka_saranan_pelulus_list) { 
           this.data.baka_saranan_pelulus_list.forEach(item => {
             if (item.lkp_baka_saranan_pelulus_id == item.id) {  
               this.klickPiPelulus(item, item.lkp_baka_saranan_pelulus_id);
             }
           });
         }
       });
     }
   },
     getBakaSaranan(){
      this.$zcomm.get(this.api_service + 'lookup/lkp_baka_saranan', {}).then(res => {
        this.lkp_baka_saranan = res
      })
    },




  klickPi(item, isChecked) {
    if (isChecked) {
    // Tandai hanya yang dipilih
      this.data.baka_saranan_list.forEach(dt => {
        dt.pilih = dt.id === item.id;
      });
    // Simpan id yang dipilih
      this.form.lkp_baka_saranan_id = item.id;
    } else {
    // Kalau tidak dicentang, hapus pilihan
      item.pilih = false;
      this.form.lkp_baka_saranan_id = null;
    }
  },

  klickPiPelulus(item, isChecked) {
    if (isChecked) {
    // Tandai hanya yang dipilih
      this.data.baka_saranan_pelulus_list.forEach(dt => {
        dt.pilih = dt.id === item.id;
      });
    // Simpan id yang dipilih
      this.form.lkp_baka_saranan_pelulus_id = item.id;
    } else {
    // Kalau tidak dicentang, hapus pilihan
      item.pilih = false;
      this.form.lkp_baka_saranan_pelulus_id = null;
    }
  },


  openZoomModal(imageUrl) {
    this.zoomedImageUrl = imageUrl;
    this.zoomModalVisible = true;
  },

  deletelAttahecmentImg(id) {
    // Your delete implementation here
  },

  nl2br(text) {
       if (!text) return '';
       return text.replace(/\\n/g, '<br>');
     },

 
  tutup(){
      this.$inertia.visit(window.route('baka.permohonan.baka_show',this.data.baka_id));
    },


  tutup1(){
         this.$inertia.visit(window.route('baka.index'));
       },
  
  },

  watch: {

  },
  mounted() {
   if(this.data.jantina==1)
    {
      this.title = 'Senarai Ternakan'
    }
    else
    {
      this.title = 'Senarai Ternakan'
    }
   this.getData()
   this.getBakaSaranan()
   // this.getPremis();
   // this.getPenilai();
   // this.getPremisCarian();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>

<style>
:root {
  --primary-color: #1976d2;
  --secondary-color: #26a69a;
  --accent-color: #9c27b0;
  --error-color: #ff5252;
  --info-color: #2196f3;
  --success-color: #4caf50;
  --warning-color: #fb8c00;
  --section-bg: #f8f9fa;
  --card-shadow: 0 3px 10px rgba(0,0,0,0.08);
}

/*.w-card {
  box-shadow: var(--card-shadow);
  border-radius: 8px;
  overflow: hidden;
}*/

.blue-gradient--bg {
  background: linear-gradient(135deg, var(--primary-color), #074c82) !important;
}

.form-section {
  margin-bottom: 1.5rem;
  padding: 1.5rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  border-left: 4px solid var(--primary-color);
  transition: all 0.3s ease;
}

.form-section:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.section-title {
  color: var(--primary-color);
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.section-title i {
  margin-right: 10px;
  font-size: 1.1em;
}

.sub-section {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: var(--section-bg);
  border-radius: 6px;
}

.sub-section-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
}

.sub-section h4 {
  color: #455a64;
  margin: 0 0.5rem 0 0;
  font-size: 1rem;
  font-weight: 500;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.form-field {
  flex: 1;
  min-width: 200px;
}


.blue-gradient--bg {
  background: linear-gradient(135deg, #074c82, #074c82) !important;
}

.genital-exam-container {
  padding: 1rem;
}

.exam-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.exam-item {
  /*padding: 1.5rem;*/
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  padding: 12px;
  border: 1px solid #e0e0e0;
  background: white;
}

.exam-item:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.exam-item.full-width {
  grid-column: 1 / -1;
}

.section-header.full-width {
  grid-column: 1 / -1;
}

.exam-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.exam-title {
  margin: 0;
  font-size: 1.0rem;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
}


.abnormal-input {
  margin-top: 1rem;
}

.exam-title {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  justify-content: space-between;
}


.score-value {
  margin-left: 15px;
  padding: 4px 12px;
  background-color: #f0f0f0;
  border-radius: 16px;
  font-weight: bold;
  color: #333;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  min-width: 24px;
  text-align: center;
}

.details {
  margin-top: 8px;
  padding: 8px;
  border-radius: 4px;
  font-size: 1.1rem;
}

.input-hint {
  color: black;
  font-size: 1.2rem;
  display: block;
  margin-top: 8px;
}


.image-gallery-container {
  padding: 16px;
  border-bottom: 1px solid #eee;
}

.gallery-title {
  margin-bottom: 12px;
}

.gallery-title h3 {
  font-size: 16px;
  color: #333;
}





.image-container {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center; 
  align-items: center; 
  overflow: hidden;
  margin-bottom: 8px;
}

.zoomable-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; 
  cursor: pointer;
  transition: transform 0.2s;
}

.zoomable-image:hover {
  transform: scale(1.02);
}




.zoom-modal-content {
  position: relative;
  text-align: center;
}

.full-zoom-image {
  max-width: 90vw;
  max-height: 80vh;
  margin-bottom: 16px;
}

.close-zoom-btn {
  margin-top: 16px;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); 
  gap: 16px;
  max-width: 380px; 
  margin: 0 auto; 
  padding: 16px;
  justify-content: center;
}

.gallery-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}

.image-wrapper {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.gallery-image {
  width: 100%;
  height: auto;
  border-radius: 4px;
  cursor: pointer;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.gallery-image:hover {
  transform: scale(1.05);
}

.image-actions {
  margin-top: 8px;
  display: flex;
  justify-content: center;
  gap: 8px;
}






/*.score-value {
  margin-left: auto;
  padding-left: 10px;
  font-weight: bold;
  font-size: 1.2rem;
}*/


.info-icon {
  color: #1976d2;
  cursor: pointer;
  font-size: 16px;
}

.exam-icon {
  font-size: 8px;
  color: #1976d2;
}


/* Responsive adjustments */
@media (max-width: 768px) {
  .exam-grid {
    grid-template-columns: 1fr;
  }
}

</style>
